import Axios from "../../axios-default"

const state = {
  controllers: null,
  controllersLoading: false,
  controllersSyncTime: null,
  controllersSyncPeriod: 1000 * 60 * 30
};

const getters = {
  controllers: state => {
    if (state.controllers) {
      return state.controllers
    }  else {
      return null;
    }
    /*else if (localStorage.getItem('controllers')) {
      return localStorage.getItem('controllers');
    }*/
  },
  controllerById: (state, getters) => (id) => {
    if (getters.controllers !== null) {
      return getters.controllers.find(controller => controller.controllerId == id)
    } else {
      return null
    }
  }
};

const mutations = {
  setControllersLoading(state, loading) {
    state.controllersLoading = loading;
  },
  setControllers(state, controllersData) {
    state.controllers = controllersData;
    //tymczas
    //state.controllers[0].controllerId = '20543466574D510D';
    state.token = '3eced465abde802fbf1bb091a4a16972';
  },
  setControllersSyncTime(state, syncTime) {
    state.controllersSyncTime = syncTime
  }
};

const actions = {
  async addController ({commit}, controllerData) {
    try {
      const res = await Axios.post('/api/sterownik/dodaj?t='+Date.now(), controllerData);

      if (typeof res.data !== 'object') {
        //commit("alert", {color: "error", text: '0'}, { root: true });
        res.data = {error:{code:'0'}};
      } else if (!res.data.controllerId && !res.data.error) {
        res.data = {error:{code:'0'}};
      }
      return res.data;
    }
    catch (error) {
      return console.log(error);
    }
  },
  async updateController ({commit}, controllerData) {
    try {
      const res = await Axios.post('/api/sterownik/edytuj?t='+Date.now(), controllerData);
      if (typeof res.data !== 'object') {
        res.data = {error:{code:'0'}};
      } else if (!res.data.controllerId && !res.data.error) {
        res.data = {error:{code:'0'}};
      }
      return res.data;
    }
    catch (error) {
      return console.log(error);
    }
  },
  async deleteController({commit, rootGetters, state}, { controllerId }) {
    try {
      //if (!state.saving) {
        //commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', controllerId);
        formData.append('token', rootGetters.token);

        const res = await Axios.post('/api/sterownik/usun?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setControllers', null);
          commit('setControllersSyncTime', null);
        }
        //commit('setSaving', false);
        return res.data;
      //}
    }
    catch (error) {
      return console.log(error);
    }
  },
  async syncControllers ({commit, dispatch, rootGetters}, forced) {
    try {
      if (!state.controllersLoading && (forced || state.controllersSyncTime === null || new Date().getTime() - state.controllersSyncTime > state.controllersSyncPeriod)) {
        commit('setControllersLoading', true);
        const formData = new URLSearchParams();
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/lista?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          commit("alert", {color: "error", text: '0'}, { root: true });
          commit('setControllersSyncTime', null);
          res.data = {error:{code:'0'}};
        } else {
          commit('setControllers', res.data);
          dispatch('saveControllers');
          commit('setControllersSyncTime', new Date().getTime());
        }
        commit('setControllersLoading', false);
        return res.data;
      } else {
        return {};
      }
    }
    catch (error) {
      return {error:{code:'0'}};
    }
  },
  saveControllers ({commit, state}) {
    localStorage.setItem('controllers', JSON.stringify(state.controllers));
  },
  resurrectControllers ({commit}) {
    if (localStorage.getItem('controllers')) { 
      commit('setControllers', JSON.parse(localStorage.getItem('controllers')));
    }
  },
  forgetControllers ({commit}) {
    commit('setControllers', null);
    commit('setControllersSyncTime', null);
    localStorage.removeItem('controllers');
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}
